import {atomButtonColors, atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import {listFiltersPlaces} from '@adv-mt/mt-list-filters'
import {searchTagsPlaces} from '@adv-mt/mt-search-tags'

export const DESIGNS = {
  BASIC: 'basic',
  HIGHLIGHTED: 'highlighted',
  PRIMARY: 'primary',
  COMPRESSED: 'compressed'
}

export const BUTTON_PROPS = {
  [DESIGNS.BASIC]: {
    color: atomButtonColors.NEUTRAL,
    design: atomButtonDesigns.FLAT,
    shape: atomButtonShapes.ROUNDED
  },
  [DESIGNS.HIGHLIGHTED]: {
    color: atomButtonColors.PRIMARY,
    design: atomButtonDesigns.OUTLINE,
    fullWidth: true,
    shape: atomButtonShapes.CIRCULAR
  },
  [DESIGNS.PRIMARY]: {
    color: atomButtonColors.PRIMARY,
    design: atomButtonDesigns.SOLID,
    shape: atomButtonShapes.CIRCULAR
  },
  [DESIGNS.COMPRESSED]: {
    color: atomButtonColors.PRIMARY,
    design: atomButtonDesigns.FLAT,
    iconSize: atomIconSizes.medium,
    shape: atomButtonShapes.CIRCULAR,
    size: atomButtonSizes.LARGE
  }
}

export const BASE_CLASS = 'mt-SearchFilters'

export const SEARCH_FILTERS_PLACES = {
  ADS_LIST: 'adsList',
  SUBSCRIPTION_ADS_LIST: 'subscriptionAdsList',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  PROFESSIONAL_STOCK: 'professionalStock'
}

export const SEARCH_FILTERS_PLACES_DICTIONARY = {
  [SEARCH_FILTERS_PLACES.ADS_LIST]: listFiltersPlaces.MODAL,
  [SEARCH_FILTERS_PLACES.SUBSCRIPTION_ADS_LIST]: listFiltersPlaces.MODAL,
  [SEARCH_FILTERS_PLACES.PROFESSIONAL_STOCK]: listFiltersPlaces.MODAL
}

export const PLACES = {
  ADS_LIST: 'adsList',
  DEALERS_LIST: 'dealersList',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  PROFESSIONAL_STOCK: 'professionalStock',
  SUBSCRIPTION_ADS_LIST: 'subscriptionAdsList',
  TECHNICAL_DETAILS: 'technicalDetails'
}

export const SEARCH_TAGS_PLACES_DICTIONARY = {
  [PLACES.ADS_LIST]: searchTagsPlaces.ADS_LIST,
  [PLACES.SUBSCRIPTION_ADS_LIST]: searchTagsPlaces.SUBSCRIPTION_ADS_LIST,
  [PLACES.PROFESSIONAL_STOCK]: searchTagsPlaces.PROFESSIONAL_STOCK
}

export const SEARCH_USE_CASE_BY_PLACE = {
  [PLACES.ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK]: 'get_stock_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK_RENTING]: 'get_stock_url_params_search_use_case',
  [PLACES.SUBSCRIPTION_ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.TECHNICAL_DETAILS]: 'get_search_url_vehicles_use_case'
}

export const DEFAULT_SEARCH_USE_CASE = 'get_search_url_ads_use_case'
